import React, { useState } from 'react';
import { Drawer, Menu, FloatButton } from 'antd';
import { MenuOutlined, SolutionOutlined, MailOutlined, InfoCircleOutlined, HomeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'; // Import Link from React Router


export function SideButtons() {
  return (
    <FloatButton.Group
      shape="square"
      style={{
        position:'fixed',
        right: 0,
        top: '30%',
        boxShadow: 'none',
        // width: 'fit-content',
        marginRight:'0.3rem',
        zIndex:'999'
      }}
    >
      <Link to="/" style={{ textDecoration: 'none' }}>
        <FloatButton
          className="custom-button"
          icon={<HomeOutlined style={{ color: "black", backgroundColor:'#ffba03', alignItems:'center'}} />}
          title="Home"
          style={{
            backgroundColor:'#ffba03'
          }}
        />
      </Link>

      <Link to="/aboutus" style={{ textDecoration: 'none'}}>
        <FloatButton
          className="custom-button"
          icon={<InfoCircleOutlined style={{ color: "black", backgroundColor:'lightblue', alignItems:'center'}} />}
          title="About Us"
          style={{
            backgroundColor:'lightblue'
          }}
        />
      </Link>

      <Link to="/career" style={{ textDecoration: 'none' }}>
        <FloatButton
          className="custom-button"
          icon={<SolutionOutlined style={{ color: "black", backgroundColor:'pink', alignItems:'center'}} />}
          title="Career"
          style={{
            backgroundColor:'pink'
          }}
        />
      </Link>

      <Link to="/contact" style={{ textDecoration: 'none' }}>
        <FloatButton
          className="custom-button"
          icon={<MailOutlined style={{ color: "black", backgroundColor:'lightgreen', alignItems:'center'}} />}
          title="Contact"
          style={{
            backgroundColor:'lightgreen'
          }}
        />
      </Link>

    </FloatButton.Group>
  )
}


const { SubMenu } = Menu;

function getItem(label, key, icon, link, children, type) {
  return {
    key,
    icon,
    children,
    label,
    link,
    type,
  };
}

const items = [
  getItem('Home', 'sub5', null, '/'),
  getItem('About Us', 'sub1', null, null, [
    getItem('Who Are We', 'option1', null, '/aboutus'),
    // getItem('Board of Directors', 'option2', null, '/directors'),
    getItem('Awards & Recognition', 'option3', null, '/awards'),
    getItem('Mission', 'option4', null, '/mission'),
    getItem('Certification', 'option5', null, '/certification'),
  ]),
  getItem('Business', 'sub2', null, '/nav2', [
    getItem('Properties', 'option5', null, '/properties'),
    getItem('Digitalization', 'option6', null, '/digitalization'),
    getItem('Covid-19 Compliant', 'option7', null, '/covidcompliant'),
  ]),
  getItem('Career', 'sub6', null, '/career'),
  getItem('Contact us', 'sub6', null, '/contact'),
];


const Sidebar = () => {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <div style={{ 
      display:'flex', 
      flexDirection:'column', 
      alignItems:'center', 
      // justifyContent:'space-between', 
      marginTop:'1rem',
    }}>
      <MenuOutlined onClick={showDrawer} style={{fontSize: '36px', cursor: 'pointer', alignContent: 'center' }} />
      <Drawer
        // title="Menu"
        placement="left"
        closable={false}
        onClose={onClose}
        visible={visible}
      >
        <Menu
          onClick={onClose}
          style={{
            height:'50%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            fontSize:'1.2rem',
            fontWeight:'600',
            padding:'0.5rem 0',
            borderInlineEnd: 'none',
          }}
          mode="vertical"
        >
          {items.map(item => (
            item.children ? (
              <SubMenu key={item.key} title={item.label} icon={item.icon}>
                {item.children.map(subItem => (
                  <Menu.Item key={subItem.key} icon={subItem.icon} style={{ fontSize:'1.1rem', fontWeight:'600'}}>
                    <Link to={subItem.link}>{subItem.label}</Link>
                  </Menu.Item>
                ))}
              </SubMenu>
            ) : (
              <Menu.Item key={item.key} icon={item.icon}>
                <Link to={item.link}>{item.label}</Link>
              </Menu.Item>
            )
          ))}
        </Menu>
      </Drawer>
      <div className='rightsidelinks'>
          <SideButtons/>
      </div>
    </div>
  );
};
export default Sidebar;
